export const provisioningPending = (state) => ['pending', 'sending', 'retry'].includes(state);
export const ownershipConflict = (code) => ['ACCOUNT_OWNERSHIP_PROOF_REQUIRED', 'ACCOUNT_OWNERSHIP_PROOF_INVALID', 'ACCOUNT_LINK_CONFLICT', 'ACCOUNT_IDENTITY_CHANGED'].includes(code || '');
